export default __webpack_public_path__ + "static/70-303d1d7023ed4e8948f9d60d6a8ed589.png";